export const CP_APP_SOURCE = "CP App";
export const SITE_VISIT_COMMENT_MIN_CHARS = 20;

export const isCpAppSource = (source?: string | null) => source === CP_APP_SOURCE;

// Same rule the dialog has always used: spaces and line breaks do not count
export const countCommentChars = (comment: string) => comment.replace(/\s/g, "").length;

const HTML_ENTITIES: Record<string, string> = {
	"&nbsp;": " ",
	"&amp;": "&",
	"&lt;": "<",
	"&gt;": ">",
	"&quot;": '"',
	"&#39;": "'",
};

// Single pass, so "&amp;lt;" becomes "&lt;" and not "<"
export const decodeHtmlEntities = (text?: string | null) =>
	(text ?? "").replace(/&(?:nbsp|amp|lt|gt|quot|#39);/g, (entity) => HTML_ENTITIES[entity]);

export type BlockedContentType = "phone" | "email" | "discount";

const BLOCKED_PATTERNS: { type: BlockedContentType; pattern: RegExp }[] = [
	// Indian mobile, with or without +91. Digits glued to a longer number are not matched.
	{ type: "phone", pattern: /(?:^|\D)(?:\+?91[\s-]?)?[6-9]\d{9}(?!\d)/ },
	{ type: "email", pattern: /[^\s@]+@[^\s@]+\.[a-z]{2,}/i },
	{ type: "discount", pattern: /\bdiscount|\boffer(?:ed)?\s+price|\bfinal\s+price|\bcash\b/i },
];

export const getBlockedContentType = (comment: string): BlockedContentType | null =>
	BLOCKED_PATTERNS.find(({ pattern }) => pattern.test(comment))?.type ?? null;
